import {
  BooleanField,
  findObjectForPropertyInModelContext,
  IModelContext,
  ModelDependency,
  ModelGroup,
  StringField
} from '@mng/model';
import { StammdatenBase } from '../allgemein/stammdaten-base';
import { SvPerson } from '../svangebot.model.types';
import { ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN } from '../svangebot.model.paths';
import { svPersonenValidation } from './svperson.validation';

export function createSvPersonenDataModelGroup(): ModelGroup {
  return new ModelGroup('svPersonenData')
    .withValidation(svPersonenValidation)
    .addArrayGroupObject(createSvPersonenModelGroup());
}

export function createSvPersonenModelGroup(id = 'personen'): ModelGroup {
  const personModelGroup: ModelGroup = new ModelGroup(id, 'SvPerson').withInterfaceName('SvPerson');

  const stammdaten = new StammdatenBase();
  stammdaten.init(true, true);
  stammdaten.adresse.withInterfaceName('SvAdressModelData');

  const stammdatenModelGroup = stammdaten.createStammdatenModelGroup().withInterfaceName('SvStammdaten');

  personModelGroup.addItems(
    new StringField('id'),
    createHauptwohnsitzAttribut(),
    stammdatenModelGroup,
    createSvPersonRollenModelGroup()
  );

  return personModelGroup;
}

function createSvPersonRollenModelGroup(): ModelGroup {
  return new ModelGroup('personRollen', 'Rollen Person')
    .withInterfaceName('SvPersonRollen')
    .addItems(
      new BooleanField('vn', 'VN').withReadOnly(),
      new BooleanField('vn2', 'VN2').withReadOnly(),
      new BooleanField('vp', 'VP').withReadOnly()
    );
}

export function createHauptwohnsitzAttribut(): BooleanField {
  const desc = 'Haben Sie Ihren Hauptwohnsitz und privaten Lebensmittelpunkt in Österreich?';
  return new BooleanField('hauptwohnsitzOesterreich', desc).withFunctionDependency(
    (dependency: ModelDependency, modelContext: IModelContext) => {
      const svPerson: SvPerson = findObjectForPropertyInModelContext(
        modelContext,
        ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN
      );
      return svPerson.personRollen?.vn || svPerson.personRollen?.vn2;
    }
  );
}
